import { Component, Input, OnInit } from '@angular/core';
import { FormHelper } from '../../helpers/form.helper';
import { IonicHelper } from '../../helpers/ionic.helper';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EventService } from '../../services/event.service';
import { Location, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ApiService } from '../../services/api.service';
import { Feedback } from '../../app/app.interfaces';



@Component({
  selector: 'feedback-modal',
  templateUrl: 'feedback-modal.html',
  providers: [Location, {provide: LocationStrategy, useClass: HashLocationStrategy}],
})

export class FeedbackModal implements OnInit {

  @Input() show: boolean;
  form: FormGroup;

  constructor(private formHelper: FormHelper,
              private ionicHelper: IonicHelper,
              private eventService: EventService,
              private formBuilder: FormBuilder,
              private apiService: ApiService) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      description: ['', Validators.compose([Validators.minLength(10), Validators.maxLength(500)])]
    });
  }

  togglePopup(activate): void {
   this.show = activate;
    this.eventService.toggleFeedbackForm.emit(this.show);
  }

  submitForm(): void {
    this.ionicHelper.toggleLoader(true);

    if(this.form.valid){

      const feedback: Feedback = {
        description: this.form.get('description').value,
        url: window.location.href
      };

      this.apiService.createResource('feedback', feedback).then(() => {
        this.ionicHelper.toggleLoader(false);
        this.togglePopup(false);
        this.ionicHelper.toast('FEEDBACK.PLACED');

        this.form.reset();
      }).catch((err) => {
        console.error(err);
        this.ionicHelper.toggleLoader(false);
        this.ionicHelper.alert('GLOBAL.GENERAL_ERROR');
      });
    } else {
      this.ionicHelper.toggleLoader(false);
      this.ionicHelper.invalidFieldsAlert(
        'FEEDBACK.ERROR',
        'FEEDBACK.TRY_AGAIN',
        'FEEDBACK.ERRORS',
        FormHelper.getInvalidFormControls(this.form.controls)
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/partials/feedback-modal/feedback-modal.ts